import { useState, useEffect } from 'react';
import { ComboBox } from '@teo/components';
import { parseFilter } from '@/util';
import { useTranslation } from 'react-i18next';

const ContacsList = ({
  Icon,
  fetch,
  defaultSort,
  render,
  onChange,
  value,
  ...other
}) => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState('');
  const [data, setData] = useState([]);
  const [count, setCount] = useState(10);
  const [newList, setNewList] = useState(null);
  const [finalList, setFinalList] = useState(null);

  const result = fetch({
    offset: 0,
    count: count,
    sort: defaultSort.map((sort) => (sort.desc ? '-' : '') + sort.id).join(','),
    q: parseFilter(filter),
  });

  useEffect(() => {
    if (newList) {
      newList?.length < 10
        ? newList?.length === result?.data?.data?.length
          ? setFinalList(newList)
          : result?.data?.data?.length >= count
          ? setCount((prev) => prev + (10 - newList.length))
          : setFinalList(newList)
        : setFinalList(newList);
    }
  }, [newList]);

  useEffect(() => {
    if (result?.data) {
      setNewList(result?.data?.data);
    }
  }, [result?.data]);

  useEffect(() => {
    if (finalList) {
      const newData = [
        // { id: null, contactName: '-unselected' },
        ...finalList,
      ].map((x) => {
        Object.assign(x, { label: render(x) });
        return x;
      });
      setData(newData);
    }
  }, [finalList]);

  return (
    <ComboBox
      Icon={Icon}
      onChange={(param) => {
        setFilter('');
        onChange(param);
      }}
      onCommitQuery={(email) => {
        setFilter('');
      }}
      options={data}
      query={filter}
      placeholder={t('pages.learning_path.settings.none_selected')}
      setQuery={(query) => {
        if (!query) {
          onChange(null);
        }
        setFilter(query);
        setCount(10);
      }}
      value={value || []}
      {...other}
    />
  );
};

export { ContacsList };
